import { CODELESS_CONVERSION_TYPE_OPTIONS } from '../../config/codelessConversionTypeOptions';
import { useCurrentConversion } from '../../hooks/useCurrentConversion';
import { ButtonAnalyzer } from '../ButtonAnalyzer/ButtonAnalyzer';
import { SetupURLEvent } from '../SetupURLEvent/SetupURLEvent';

export const ConversionTypeContent = ({ currentIndex, styleFrame, ...props }) => {
    const currentConversion = useCurrentConversion(currentIndex);
    const conversionType = currentConversion?.conversionType;

    if (conversionType === CODELESS_CONVERSION_TYPE_OPTIONS.BUTTON_CLICKS) {
        return <ButtonAnalyzer currentIndex={currentIndex} styleFrame={styleFrame} {...props} />;
    }

    return <SetupURLEvent currentIndex={currentIndex} {...props} />;
};
